var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 209,
    viewBox: "0 0 248 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.018 1.02851C232.031 -0.321022 235.58 1.02381 236.808 4.08861C248.761 33.9302 250.761 66.8971 242.414 98.0517C233.55 131.134 213.56 160.153 185.807 180.224C158.055 200.295 124.235 210.193 90.0408 208.25C57.8393 206.421 27.157 194.198 2.5598 173.501C0.0336055 171.375 -0.132283 167.584 2.09296 165.145C4.3182 162.706 8.09114 162.544 10.6247 164.66C33.186 183.51 61.2613 194.641 90.7188 196.314C122.169 198.1 153.275 188.997 178.801 170.537C204.326 152.076 222.713 125.386 230.865 94.9574C238.501 66.4577 236.723 36.3089 225.886 8.97948C224.669 5.91041 226.005 2.37804 229.018 1.02851Z",
    fill: "url(#paint0_linear_710_30224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_30224",
    x1: 96.9925,
    y1: -89.5023,
    x2: 99.988,
    y2: 208.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FC69A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2E86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBorder);
export default __webpack_public_path__ + "static/media/bottom-border.20edfe7241db0477a5e16499846d54d2.svg";
export { ForwardRef as ReactComponent };